import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SiteToken } from '@sleed/bizcommerce-api';
import { sitesApi } from '~/lib/api/client';
import { formToToken, type SiteFormValues } from '~/lib/schemas/site';

export const siteAdminKeys = { all: ['sites-admin'] as const, list: () => [...siteAdminKeys.all, 'list'] as const };

export function useSitesAdminList() {
	return useQuery<SiteToken[]>({
		queryKey: siteAdminKeys.list(),
		queryFn: async () => (await sitesApi.getAll()).data.items ?? []
	});
}

export function useSiteMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: siteAdminKeys.list() });
	const create = useMutation({
		mutationFn: async (form: SiteFormValues) => (await sitesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: SiteFormValues) => (await sitesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await sitesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
